/* eslint-disable prettier/prettier */
/**
 * Typography used in theme
 * @param {JsonObject} theme theme customization object
 */
import { createTheme } from '@mui/material/styles';
const muiTheme = createTheme(); // gives access to default breakpoints

export default function themeTypography(theme) {
    return {
        // Base font family from customization settings
        fontFamily: theme?.customization?.fontFamily,

        // Header styles
        h6: {
            fontWeight: 500,
            color: '#03045E', // primary heading color
            fontSize: '0.75rem' // small heading
        },
        h5: {
            fontSize: '0.875rem',
            color: '#03045E',
            fontWeight: 500
        },
        h4: {
            fontSize: '1rem',
            color: '#03045E',
            fontWeight: 600
        },
        h3: {
            fontSize: '1.25rem',
            color: '#03045E',
            fontWeight: 600
        },
        h2: {
            fontSize: '1.5rem',
            color: '#03045E',
            fontWeight: 700
        },
        h1: {
            fontSize: '2.125rem',
            color: '#03045E',
            fontWeight: 700
        },

        // Subtitle styles
        subtitle1: {
            fontSize: '0.875rem',
            fontWeight: 500,
            color: '#03045E'
        },
        subtitle2: {
            fontSize: '0.75rem',
            fontWeight: 400,
            color: '#03045E'
        },

        // Caption text style
        caption: {
            fontSize: '0.75rem',
            color: '#03045E',
            fontWeight: 400
        },

        // Body text styles
        body1: {
            fontSize: '1rem',
            fontWeight: 700,
            lineHeight: '1.334em',
            color: '#03045E'
        },
        body2: {
            letterSpacing: '0em',
            fontFamily: 'Open Sans Regular',
            fontSize: '1rem',
            lineHeight: '1.5em',
            color: '#03045E'
        },

        // Custom font families
        openSansRegular: {
            fontFamily: 'Open Sans Regular'
        },
        openSansBold: {
            fontFamily: 'Open Sans Bold'
        },

        // Button text style
        button: {
            textTransform: 'capitalize' // Capitalize first letter only
        },

        // Anchor tag style
        a: {
            color: '#03045E !important' // Ensure consistent link color
        },

        // Style for custom input fields
        customInput: {
            marginTop: 1,
            marginBottom: 1,
            '& > label': {
                top: 23,
                left: 0,
                color: '#03045E', // Label text color
                '&[data-shrink="false"]': {
                    top: 5 // Adjust label when input is not focused
                }
            },
            '& > div > input': {
                padding: '30.5px 14px 11.5px !important' // Padding for input box
            },
            '& legend': {
                display: 'none' // Hide fieldset legend
            },
            '& fieldset': {
                top: 0 // Align fieldset to top
            }
        },

        // Main content container style
        mainContent: {
            backgroundColor: theme.background, // Set background from theme
            width: '100%',
            [muiTheme.breakpoints.down('lg')]: {
                minHeight: '100vh'
            },
            [muiTheme.breakpoints.up('md')]: {
                minHeight: '100vh'
            },
            [muiTheme.breakpoints.down('md')]: {
                minHeight: '100vh' // Tablet & Mobile
            },
            [muiTheme.breakpoints.down('sm')]: {
                minHeight: 'calc(100vh)'
            },
            // minHeight: 'calc(40vh)', // Full viewport height
            flexGrow: 1, // Allow flex expansion
            padding: '20px',
            marginTop: '55px',
            // marginRight: '20px', // Optional right margin (commented out)
            borderRadius: `${theme?.customization?.borderRadius}px` // Rounded corners from theme
        },

        // Menu section headers
        menuCaption: {
            fontSize: '0.875rem',
            fontWeight: 500,
            color: '#03045E',
            padding: '6px',
            textTransform: 'capitalize',
            marginTop: '10px'
        },

        // Submenu text style
        subMenuCaption: {
            fontSize: '0.6875rem',
            fontWeight: 500,
            color: '#03045E',
            textTransform: 'capitalize'
        },

        // Avatar styles (clickable images/icons)
        commonAvatar: {
            cursor: 'pointer',
            borderRadius: '8px' // Rounded avatar
        },
        smallAvatar: {
            width: '22px',
            height: '22px',
            fontSize: '1rem'
        },
        mediumAvatar: {
            width: '34px',
            height: '34px',
            fontSize: '1.2rem'
        },
        largeAvatar: {
            width: '44px',
            height: '44px',
            fontSize: '1.5rem'
        },

        // Default color for span elements
        span: {
            color: '#03045E'
        },

        // Default color for div elements
        div: {
            color: '#03045E'
        }
    };
}
